import React, { PureComponent } from 'react';
import { Col } from "antd";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ChartRenderer from "../components/ChartRendererScoreboard";
import Dashboard from "../components/Dashboard";
import DashboardItem from "../components/DashboardItem";
import { Multiselect } from 'multiselect-react-dropdown';
// import Tooltip from '@bit/recharts.recharts.tooltip';
import 'antd/dist/antd.css';
import { Radio, Checkbox } from 'antd';

// import moment from "moment";
// const dateFormatter = item => moment(item).format("MMM 'YY"); 



const optionsGranularityoriginal = [
  { label: 'None', value: undefined, forDateRange: 'Today, This week, This month, This quarter, This year, all' },
  { label: 'Hour', value: 'hour', forDateRange: 'Today, This week' },
  { label: 'Day', value: 'day', forDateRange: 'This week, This month' },
  { label: 'Week', value: 'week', forDateRange: 'This month, This quarter' },
  { label: 'Month', value: 'month', forDateRange: 'This quarter, This year, all' },
  { label: 'Year', value: 'year', forDateRange: 'all' }
];


class CustomerDashboardPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      facilityList: ['286'], //["101"],
      optionsGranularity: optionsGranularityoriginal.filter(group => group.forDateRange.indexOf('This week') >= 0), // optionsGranularityoriginal,
      dateRangeList: 'This week', // undefined, // from 6 days ago to now
      granularity: undefined,  // 'year', //undefined,
      //dateRangeList: [`08/12/2019`,`09/01/2020`],
      //dateRangeList:"Last 2 quarter",
      optionsForBPName: [
        {
          "name": "Langer Transport Corporation",
          "value": "Langer Transport Corporation",
          catName: "Customer name",
          catShortName: "Cu"
        },
        {
          "name": "Quest Liner Inc",
          "value": "Quest Liner Inc",
          catName: "Customer name",
          catShortName: "Cu"
        },
        {
          "name": "3D Corporate Solutions LLC (Retail)",
          "value": "10003",
          catName: "Customer name",
          catShortName: "Cu"
        },
        {
          "name": "DRPAMJ Transport",
          "value": "14166",
          catName: "Customer name",
          catShortName: "Cu"
        },
        {
          "name": "Behrens Trucking",
          "value": "13549",
          catName: "Customer name",
          catShortName: "Cu"
        },
        {
          "name": "RRM Trucking",
          "value": "14256",
          catName: "Customer name",
          catShortName: "Cu"
        },
        {
          "name": "NCT Truck & Trailer",
          "value": "13977",
          catName: "Customer name",
          catShortName: "Cu"
        },
        {
          "name": "Truck Logistic Service",
          "value": "14003",
          catName: "Customer name",
          catShortName: "Cu"
        },
        {
          "name": "Epic Trans",
          "value": "13972",
          catName: "Customer name",
          catShortName: "Cu"
        }
      ],
      bpNameList: [], // ['Langer Transport Corporation'],
      selectedValueBPName: [],
      displayBy: 'This week',
      isPreviousChecked: false,
      additionalSearchText: 'week',
      chartType: 'pie',
      timeSliceValue :undefined,
      size: 'large',
     //  treeDataProductCustomer: treeDataProductCustomer
    };
    this.style = {
      chips: {
        background: "red"
      },
      searchBox: {
        border: "none",
        "border-bottom": "1px solid #001529",
        "border-radius": "0px"
      }
    };
  }

  // classes = useStyles();

  onSelectBPName = (selectedList, selectedItem) => {
    this.setState({
      bpNameList: [...this.state.bpNameList, selectedItem.value],
      selectedValueBPName: selectedList,
    });
  };

  onRemoveBPName = (selectedList, removedItem) => {
    this.setState({
      bpNameList: this.state.bpNameList.filter(
        (item) => item !== removedItem.value
      ),
      selectedValueBPName: selectedList,
    });
  };

  resetGranulary = (searchValue) => {
    if (searchValue === undefined) { searchValue = 'all' }
    var filtered = optionsGranularityoriginal.filter(group => group.forDateRange.indexOf(searchValue) >= 0);
    console.log('filtered Array', filtered);
    this.setState({ optionsGranularity: filtered });
  }


  handleDisplayByChange = e => {
    
    var dateRange = e.target.value;
    this.setState({ isPreviousChecked: false, timeSliceValue: undefined, chartType: 'pie', granularity: undefined  });
  
    if (dateRange === 'This year') {
      this.setState({ displayBy: 'This year', additionalSearchText: 'year' });
    } else if (dateRange === 'This quarter') {
      this.setState({ displayBy: 'This quarter', additionalSearchText: 'quarter' });
    } else if (dateRange === 'This month') {
      this.setState({ displayBy: 'This month', additionalSearchText: 'month' });
    } else if (dateRange === 'This week') {
      this.setState({ displayBy: 'This week', additionalSearchText: 'week' });
    } else if (dateRange === 'Today') {
      this.setState({ displayBy: 'Today', additionalSearchText: 'day' });
    } else if (dateRange === undefined) {
      this.setState({ displayBy: undefined, additionalSearchText: '' });
    } else {
      this.setState({ additionalSearchText: '' });
    }



    if (e.target.value === 'All time') {
      this.setState({ dateRangeList: undefined });
    } else {
      this.setState({ dateRangeList: e.target.value });
    }
    this.resetGranulary(e.target.value);
  };


  onChangeGranularity = e => {
    var chartType = e.target.value !== undefined ? 'bar' : 'pie';
    this.setState({
      granularity: e.target.value,
      chartType: chartType
    });
  };

  onChangeAdditionalSearchText = e => {
    this.setState({ isPreviousChecked: !this.state.isPreviousChecked });
    if (e.target.checked) {
      var dateRange = this.state.dateRangeList;
      if (dateRange === 'This year') {
        this.setState({ dateRangeList: 'Last 2 years' });
      } else if (dateRange === 'This quarter') {
        this.setState({ dateRangeList: 'Last 2 quarters' });
      } else if (dateRange === 'This month') {
        this.setState({ dateRangeList: 'Last 2 months' });
      } else if (dateRange === 'This week') {
        this.setState({ dateRangeList: 'Last 2 weeks' });
      } else if (dateRange === 'Today') {
        this.setState({ dateRangeList: 'Last 2 days' });
      } 
      
      else {
        this.setState({ additionalSearchText: '' });
      }
    } else {
      dateRange = this.state.dateRangeList;
      var displayBy = this.state.displayBy;
      if (displayBy === 'This year') {
        this.setState({ dateRangeList: 'This year' });
      } else if (displayBy === 'This quarter') {
        this.setState({ dateRangeList: 'This quarter' });
      } else if (displayBy === 'This month') {
        this.setState({ dateRangeList: 'This  month' });
      } else if (displayBy === 'This week') {
        this.setState({ dateRangeList: 'This week' });
      } else if (displayBy === 'Today') {
        this.setState({ dateRangeList: 'Today' });
      } else {
        this.setState({ additionalSearchText: '' });
      }
    }
  };

  render() {
    let managerFacilityFilter = [{
      "dimension": "AdOrg.facility",
      "operator": "contains",
      "values": this.state.facilityList
    },
    {
      "dimension": "CBpartner.name",
      "operator": "contains",
      "values": this.state.bpNameList // this.state.bpNameList
    }
    ];

    const DashboardItemsTop = [
      {
        id: 0,
        name: "Completed Work Orders",
        vizState: {
          query: {
            "measures": [
              "WorkOrder.completed_count"
            ],
            "timeDimensions": [
              {
                "dimension": "WorkOrder.start_date",
                "dateRange": this.state.dateRangeList,
                // "granularity": this.state.granularity,
              }
            ],
            "order": {
              "WorkOrder.completed_count": "desc"
            },
            "filters": managerFacilityFilter
          },
          chartType: "number"
        },
        grid: 12
      }, {
        id: 1,
        name: "Late Work Orders",
        vizState: {
          query: {
            "measures": [
              "WorkOrder.late_count"
            ],
            "timeDimensions": [
              {
                "dimension": "WorkOrder.start_date",
                "dateRange": this.state.dateRangeList
              }
            ],
            "order": {
              "WorkOrder.late_count": "desc"
            },
            "filters": managerFacilityFilter
          },
          chartType: "number"
        },
        grid: 12
      },
      {
        id: 2,
        name: "Late Work Orders Avg",
        vizState: {
          query: {
            "measures": [
              "WorkOrder.late_percent"
            ],
            "timeDimensions": [
              {
                "dimension": "WorkOrder.start_date",
                "dateRange": this.state.dateRangeList
              }
            ],
            "order": {
              "WorkOrder.late_percent": "desc"
            },
            "filters": managerFacilityFilter
          },
          chartType: "number"
        },
        grid: 12
      }, {
        id: 3,
        name: "Cancelled Orders",
        vizState: {
          query: {
            "measures": [
              "SOrder.cancelled_count"
            ],
            "timeDimensions": [
              {
                "dimension": "SOrder.so_created",
                "dateRange": this.state.dateRangeList
              }
            ],
            "order": {
              "SOrder.cancelled_count": "desc"
            },
            "filters": managerFacilityFilter
          },
          chartType: "number"
        },
        grid: 12
      }, {
        id: 4,
        name: "Cancelled Orders Percentage",
        vizState: {
          query: {
            "measures": [
              "SOrder.cancelled_percent"
            ],
            "timeDimensions": [
              {
                "dimension": "SOrder.so_created",
                "dateRange": this.state.dateRangeList
              }
            ],
            "order": {
              "SOrder.cancelled_percent": "desc"
            },
            "filters": managerFacilityFilter
          },
          chartType: "number"
        },
        grid: 12
      }, {
        id: 5,
        name: "Avg Lead Time (HH:Mi:SS)",
        vizState: {
          query: {
            "measures": [
              "WorkOrder.avg_work_order_lead_hours"
            ],
            "timeDimensions": [
              {
                "dimension": "WorkOrder.start_date",
                "dateRange": this.state.dateRangeList
              }
            ],
            "order": {
              "WorkOrder.avg_work_order_lead_hours": "desc"
            },
            "filters": managerFacilityFilter
          },
          chartType: "number"
        },
        grid: 12
      }, {
        id: 5,
        name: "Avg Completion Time (HH:Mi:SS)",
        vizState: {
          query: {
            "measures": [
              "WorkOrder.avg_work_order_duration_hours"
            ],
            "timeDimensions": [
              {
                "dimension": "WorkOrder.start_date",
                "dateRange": this.state.dateRangeList
              }
            ],
            "order": {
              "WorkOrder.avg_work_order_duration_hours": "desc"
            },
            "filters": managerFacilityFilter
          },
          chartType: "number"
        },
        grid: 12
      },


    ];
    const DashboardItems =
      [
        {
          id: 0,
          name: "By Line of Business",
          vizState: {
            query: {
              "measures": [
                "WorkOrder.completed_count"
              ],
              "timeDimensions": [
                {
                  "dimension": "WorkOrder.start_date",
                  // compareDateRange: ['this week', [`08/12/2019`,`09/01/2020`]],
                  "dateRange": this.state.dateRangeList,
                  "granularity": this.state.granularity,
                }
              ],
              "order": {
                "WorkOrder.completed_count": "desc"
              },
              "dimensions": [
                "ContainerCategory.LineOfBusiness"
              ],
              "filters": managerFacilityFilter
            },
            chartType: this.state.chartType
          }
        },

        {
          id: 1,
          name: "By Product Category",
          vizState: {
            query: {
              "measures": [
                "WorkOrder.completed_count"
              ],
              "timeDimensions": [
                {
                  "dimension": "WorkOrder.start_date",
                  "dateRange": this.state.dateRangeList,
                  "granularity": this.state.granularity,
                }
              ],
              "order": {
                "WorkOrder.completed_count": "desc"
              },
              "dimensions": [
                "ProductCategory.productCategoryName"
              ],
              "filters": managerFacilityFilter
            },
            chartType: this.state.chartType
          }
        },
        {
          id: 2,
          name: "By Customers",
          vizState: {
            query: {
              "measures": [
                "WorkOrder.completed_count"
              ],
              "timeDimensions": [
                {
                  "dimension": "WorkOrder.start_date",
                  "dateRange": this.state.dateRangeList,
                  "granularity": this.state.granularity,
                }
              ],
              "order": {
                "WorkOrder.completed_count": "desc"
              },
              "dimensions": [
                "CBpartner.name"
              ],
              "filters": managerFacilityFilter,
              // "limit": 5
            },
            chartType: this.state.chartType
          }
        },
        {
          id: 3,
          name: "By Customer Category",
          vizState: {
            query: {
              "measures": [
                "WorkOrder.completed_count"
              ],
              "timeDimensions": [
                {
                  "dimension": "WorkOrder.start_date",
                  "dateRange": this.state.dateRangeList,
                  "granularity": this.state.granularity,
                }
              ],
              "order": {
                "WorkOrder.completed_count": "desc"
              },
              "dimensions": [
                "CBpartnerCategory.bp_cat_name"
              ],
              "filters": managerFacilityFilter
            },
            chartType: this.state.chartType
          }
        }, {
          id: 5,
          name: "Cancelled Orders",
          vizState: {
            query: {
              "measures": [
                "SOrder.cancelled_count"
              ],
              "timeDimensions": [
                {
                  "dimension": "SOrder.so_created",
                  "dateRange": this.state.dateRangeList,
                  "granularity": this.state.granularity,
                }
              ],
              "order": {
                "SOrder.cancelled_count": "desc"
              },
              "dimensions": [
                "CBpartner.name"
              ],
              "filters": managerFacilityFilter,
              //"limit": 5
            },
            chartType: this.state.chartType
          }
        }


      ];
    const dashboardItem = item => (
      <Col
        span={24}
        lg={12}
        key={item.id}
        style={{
          marginBottom: "24px"
        }}
      >
        <DashboardItem title={item.name}>
          <ChartRenderer vizState={item.vizState} />
        </DashboardItem>
      </Col>
    );
    return DashboardItems.length ? (
      <Dashboard>



    

        <Grid container spacing={3} style={{ paddingLeft: 10 }} justify="" alignItems="flex-start" id="filterContainer-title">
          <Col span={24} lg={10} xs={24} sm={24} md={24}   >
            <div className="filter-bg color-1 white-bg">
              <Multiselect
                options={this.state.optionsForBPName}
                selectedValues={this.state.selectedValueBPName}
                displayValue="name"
                onSelect={this.onSelectBPName} // Function will trigger on select event
                onRemove={this.onRemoveBPName} // Function will trigger on remove event
                placeholder="Select customer name"
              />
            </div></Col>



          <Col span={24} lg={12} xs={24} sm={24} md={24}   >
            <div className="date_range">
              <div className='white-bg1 spacing'>
                <div className='' style={{ marginTop: 10, marginBottom: 20 }}>


                  <Grid container spacing={3} style={{ paddingLeft: 10, marginBottom: 10, }} justify="" alignItems="flex-start">
                    <Col span={24} lg={24} xs={24} sm={24} md={24}   >
                      
                      {/* Display By &nbsp; <br />  
                       */}
                       {/* </Col> <Col span={24} lg={20} xs={24} sm={24} md={24}   > */}
                      
                      <Radio.Group className='displayByOptions' value={this.state.displayBy} onChange={this.handleDisplayByChange}>
                        <Radio.Button value="Today">Today</Radio.Button>
                        <Radio.Button value="This week">This week</Radio.Button>
                        <Radio.Button value="This month">This month</Radio.Button>
                        <Radio.Button value="This quarter">This quarter</Radio.Button>
                        <Radio.Button value="This year">This year</Radio.Button>
                        <Radio.Button value={undefined}>All time</Radio.Button>
                      </Radio.Group>
                      <div className='clearFix'></div>
                      <div className='filter-wrapper'>
                        <div className='previousInclude' style={{ marginBottom: 10 }}>
                          {this.state.displayBy !== undefined && (
                            <Checkbox checked={this.state.isPreviousChecked} onChange={this.onChangeAdditionalSearchText}>Include last  {this.state.additionalSearchText}</Checkbox>
                          )}</div>
                          
                      <div className='clearFix'></div>
                      <div className='optionsFilter'>
                        Slice by &nbsp; &nbsp;  
                        
                        {this.state.displayBy === undefined && ( 
                        <Radio.Group name="radiogroup" options={optionsGranularityoriginal.filter(group => group.forDateRange.indexOf('all') >= 0)} 
                        defaultValue={this.state.timeSliceValue}  onChange={this.onChangeGranularity} />
                        )}

                        {this.state.displayBy === 'This year' && ( 
                        <Radio.Group name="radiogroup" options={optionsGranularityoriginal.filter(group => group.forDateRange.indexOf('This year') >= 0)} 
                        defaultValue={this.state.timeSliceValue}  onChange={this.onChangeGranularity} />
                        )}

                        {this.state.displayBy === 'This quarter' && ( 
                        <Radio.Group name="radiogroup" options={optionsGranularityoriginal.filter(group => group.forDateRange.indexOf('This quarter') >= 0)} 
                        defaultValue={this.state.timeSliceValue}  onChange={this.onChangeGranularity} />
                        )} 

                        {this.state.displayBy === 'This month' && ( 
                        <Radio.Group name="radiogroup" options={optionsGranularityoriginal.filter(group => group.forDateRange.indexOf('This month') >= 0)} 
                        defaultValue={this.state.timeSliceValue}  onChange={this.onChangeGranularity} />
                        )}

                        {this.state.displayBy === 'This week' && ( 
                        <Radio.Group name="radiogroup" options={optionsGranularityoriginal.filter(group => group.forDateRange.indexOf('This week') >= 0)} 
                        defaultValue={this.state.timeSliceValue}  onChange={this.onChangeGranularity} />
                        )}

                        {this.state.displayBy === 'Today' && ( 
                        <Radio.Group name="radiogroup" options={optionsGranularityoriginal.filter(group => group.forDateRange.indexOf('Today') >= 0)} 
                        defaultValue={this.state.timeSliceValue}  onChange={this.onChangeGranularity} />
                        )} 

                      </div>
                      <div className='clearFix'></div>
                      </div>

                    </Col>
                  </Grid>

                </div>
                {/* onChange={onChange} */}


              </div>
              <div className='clearFix'></div>

            </div>

          </Col>


        </Grid> 
        <Grid xs={12} lg={24} container spacing={3} style={{ padding: 20 }} justify="left" alignItems="flex-start">
          {/* <h1 className='main-score-card-title'>Scoreboard 101 Conley GA </h1> */}
          {this.state.dateRangeList === undefined ? (
            <h2 className='main-score-card-sub-title'>  All time  </h2>
          ) : (
              <h2 className='main-score-card-sub-title'>  {this.state.dateRangeList}  </h2>
            )}


          <br />
        </Grid>
        <Grid className='top-widgets' xs={24} lg={24} container spacing={0} style={{ padding: 0 }} justify="left" alignItems="flex-start">
          <Col span={24} lg={6} xs={24} key={DashboardItemsTop[0].id} style={{ marginBottom: "24px" }} >
            <DashboardItem title={DashboardItemsTop[0].name}>
              <ChartRenderer vizState={DashboardItemsTop[0].vizState} />
            </DashboardItem>
          </Col>
          <Col span={24} lg={6} key={DashboardItemsTop[1].id} style={{ marginBottom: "24px" }} >
            <DashboardItem title={DashboardItemsTop[1].name}>
              <ChartRenderer vizState={DashboardItemsTop[1].vizState} />
              <ChartRenderer vizState={DashboardItemsTop[2].vizState} />
            </DashboardItem>
          </Col>
          <Col span={24} lg={6} key={DashboardItemsTop[3].id} style={{ marginBottom: "24px" }} >
            <DashboardItem title={DashboardItemsTop[3].name}>
              <ChartRenderer vizState={DashboardItemsTop[3].vizState} />
              <ChartRenderer vizState={DashboardItemsTop[4].vizState} />
            </DashboardItem>
          </Col>
          <Col span={24} lg={6} key={DashboardItemsTop[5].id} style={{ marginBottom: "24px" }} >
            <DashboardItem title={DashboardItemsTop[5].name}>
              <ChartRenderer vizState={DashboardItemsTop[5].vizState} />
            </DashboardItem>
          </Col>
          <Col span={24} lg={6} key={DashboardItemsTop[6].id} style={{ marginBottom: "24px" }} >
            <DashboardItem title={DashboardItemsTop[6].name}>
              <ChartRenderer vizState={DashboardItemsTop[6].vizState} />
            </DashboardItem>
          </Col>
        </Grid>


        <Grid xs={24} lg={24} container spacing={3} style={{ padding: 0 }} justify="left" alignItems="flex-start" >
         {/* <Col span={24} lg={12} xs={24} key={DashboardItemsTop[0].id} style={{ marginBottom: "24px" }} >
         <Card title='By Product Category' style={{ height: "100%", width: "100%" }}>
         <Alert className='' severity="info">Click on the bar to open the drill down table.</Alert>
          <div className=''>   <DrillDownExample /> </div>
          </Card>
          </Col>  */}
          {DashboardItems.map(dashboardItem)}
        </Grid>


        
      </Dashboard>
    ) : (
        <div style={{ textAlign: "center", padding: 12 }}  >  <Typography variant="h5" color="inherit">  There are no charts on this dashboard. Use Playground Build to add one. </Typography>  </div>
      );



  }
}


export default CustomerDashboardPage;
